/**
 * TaxonomyKeyCard
 *
 * Card for a taxonomy key in the grid view. Shows display name,
 * taxonomy key, live version badge, draft indicator, and dimension/label counts.
 */

import React from 'react';
import VersionBadge from '../../shared/VersionBadge';
import type { TaxonomyKeySummary } from '../../types/taxonomy';

interface TaxonomyKeyCardProps {
  summary: TaxonomyKeySummary;
  onClick: () => void;
}

const TaxonomyKeyCard: React.FC<TaxonomyKeyCardProps> = ({ summary, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="w-full text-left rounded-lg border bg-white p-4 hover:border-blue-300 hover:shadow-sm transition-all h-[120px] flex flex-col"
    >
      <div className="flex items-center justify-between mb-1">
        <h3 className="font-semibold text-sm truncate">{summary.displayName}</h3>
        {summary.liveVersion && <VersionBadge status="live" />}
      </div>
      <p className="text-xs text-gray-400 font-mono truncate">{summary.taxonomyKey}</p>
      <div className="mt-auto">
        <p className={`text-xs mb-1 ${summary.hasDraft ? 'text-amber-600' : 'invisible'}`}>
          Draft pending
        </p>
        <p className="text-xs text-gray-500">
          {summary.liveVersion
            ? <>v{summary.liveVersion}{summary.labelCount !== null && ` · ${summary.labelCount} labels`}{summary.dimensionCount !== null && `, ${summary.dimensionCount} dimensions`}</>
            : <span className="text-gray-400">No versions</span>
          }
        </p>
      </div>
    </button>
  );
};

export default TaxonomyKeyCard;
